import { tw } from '~/utils/tw-merge'

export function PageSection({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={tw('max-w-screen-3xl w-full mx-auto px-4 md:px-8 xl:px-12 relative', className)} {...props} />
}
